import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ibanFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (!/^[A-Za-z]{2}/.test(value)) {
      return { invalidIban: true };
    }

    if (!/^[A-Za-z0-9]+$/.test(value)) {
      return { specialCharacters: true };
    }

    return null;
  };
}
